// src/components/Projects/index.tsx
import React from 'react';
import Container from 'react-bootstrap/Container';
import { Link } from "react-router-dom";

const Projects: React.FC = () => {
    return (
        <Container>
            <h3>Random projects</h3>
            <ul>
                <li>
                    <Link to="/projects/travel">Travel Favorites</Link>: A few of my favorite places to visit around the world
                </li>
                <li>
                    <Link to="/projects/system-design-calculator">System Design Calculator</Link>: Calculator for Byte conversion + Load conversion
                </li>
                <li>
                    <Link to="/projects/running-pace-calculator">Running Pace Calculator</Link>: Calculate your expected race finish time for a given distance based on your estimated pace
                </li>
                <li>
                    <Link to="/projects/youtube">YouTube</Link>: Experimenting with YouTube Embedded Players
                </li>
                <li>
                    <Link to="/projects/kaboom">Kaboom Game</Link>: Experimenting with Replit
                </li>
            </ul>
        </Container>
    );
};

export default Projects;

